module.exports = __webpack_public_path__ + "img/53.fd6f9de.jpg";